export const SET_LOADER = "SET_LOADER"
export const REMOVE_LOADER = "REMOVE_LOADER"